import React, { useState, useEffect } from 'react';
import { getNameClient } from '../../../helpers/nameClient';

import { Col, Row, Label, Container, Input } from 'reactstrap';

import { useSelector, useDispatch } from 'react-redux';
import PageTitle from '../../../components/Common/MetaTagsHelper/metaTagsHelper';
import Icon from '@ailibs/feather-react-ts';
import { getPermissions } from '../../../store/Permissions/actions';
import { getRoles, updateRolPermisiosn } from '../../../store/Roles/actions';
import { getClients } from '../../../store/client/actions';
import Swal from 'sweetalert2';
import './Rol-Menu-list.scss';
import usePageTitle from '../../../common/hooks/usePageTitle';

function RolMenu(props: any) {
    const dispatch = useDispatch();
    const { permissions } = useSelector((state: any) => state.Permissions);
    const { roles, error } = useSelector((state: any) => state.Roles);
    const { clients } = useSelector((state: any) => state.clients);

    const PageTitleRolM = usePageTitle(props.location.pathname);

    const [state, setState] = useState<any>({
        currentRol: 0,
        currentClient: 0,
        indexCurrentRol: null,
        currentRolPermissions: [],
        currentRolPermissionsClean: [],
        currentRolNotPermissions: [],
        allPermissionQuery: '',
        currentPermissionQuery: '',
    });

    useEffect(() => {
        dispatch(getPermissions({}));
        dispatch(getRoles({}));
        dispatch(getClients({}));
    }, [dispatch]);

    useEffect(() => {
        const currentRolPermissions = permissionData();
        const currentRolNotPermissions = notPermissionData(currentRolPermissions);
        setState({
            ...state,
            currentRolPermissions,
            currentRolNotPermissions,
            currentRolPermissionsClean: currentRolPermissions,
        });
    }, [state.currentRol, state.currentClient]);

    useEffect(() => {
        const value = state.allPermissionQuery.toLowerCase();
        let res;
        if (value.length < 3) {
            res = notPermissionData(undefined);
        } else {
            res = notPermissionData(undefined)?.filter((item: any) => item.nombre.toLowerCase().includes(value));
        }
        setState({ ...state, currentRolNotPermissions: res });
    }, [state.allPermissionQuery]);

    useEffect(() => {
        const value = state.currentPermissionQuery.toLowerCase();
        let res;
        if (value.length < 3) {
            res = state.currentRolPermissionsClean;
        } else {
            res = state.currentRolPermissionsClean?.filter((item: any) => item.nombre.toLowerCase().includes(value));
        }
        setState({ ...state, currentRolPermissions: res });
    }, [state.currentPermissionQuery]);

    const permissionData = () => {
        const newArray = permissions.filter((item: any) => {
            let valid = false;
            // eslint-disable-next-line array-callback-return
            roles[state.indexCurrentRol]?.permisos?.map((itemMap: any) => {
                if (itemMap?.id === item.id) {
                    valid = true;
                }
            });
            return valid && !item.generic && item.EMPRESA_ID === state.currentClient;
        });
        return newArray;
    };

    const notPermissionData = (array: any) => {
        const curretPermissionArray = array ?? state.currentRolPermissions;
        const newArray = permissions.filter((item: any) => {
            let valid = true;
            // eslint-disable-next-line array-callback-return
            curretPermissionArray.map((itemMap: any) => {
                if (itemMap?.id === item.id) {
                    valid = false;
                }
            });
            return valid && !item.generic && item.EMPRESA_ID === state.currentClient;
        });
        return newArray;
    };

    const changeHandler = (item: any) => {
        const newArray = state.currentRolPermissionsClean.reverse();
        newArray.push(item);
        setState({
            ...state,
            currentRolNotPermissions: notPermissionData(newArray),
            currentRolPermissions: newArray.reverse(),
            allPermissionQuery: '',
            currentPermissionQuery: '',
        });
    };

    const changeHandlerDelete = (id: any) => {
        const newArray = state.currentRolPermissionsClean.filter((item: any) => item.id !== id);
        setState({
            ...state,
            currentRolNotPermissions: notPermissionData(newArray),
            currentRolPermissions: newArray,
            currentRolPermissionsClean: newArray,
            allPermissionQuery: '',
            currentPermissionQuery: '',
        });
    };

    const updateHandler = () => {
        const newArray = state.currentRolPermissionsClean.map((item: any) => {
            return { id: item.id };
        });
        dispatch(
            updateRolPermisiosn({
                rol: { id: state.currentRol, clientId: state.currentClient, permissions: newArray },
            }),
        );
        showSwal();
    };

    const showSwal = () => {
        return error
            ? Swal.fire({
                icon: 'warning',
                title: 'Rol-Menu!',
                text: 'An error has occurred, please contact support.',
                showConfirmButton: true,
                timer: 3000,
            })
            : Swal.fire({
                icon: 'success',
                title: 'Rol-Menu!',
                text: 'New items have been added successfully!!!',
                showConfirmButton: true,
                //timer: 3000
            });
    };

    return (
        <React.Fragment>
            <Container className="mb-5">
                <Row>
                    <div id="navbar"></div>
                    <PageTitle>
                        <title>{PageTitleRolM.replace(/-/g, ' ')} | {getNameClient()}</title>
                    </PageTitle>
                </Row>
                <Row>
                    <Col sm={12}>
                        <Container fluid className="p-5">
                            <Row className="justify-content-center mb-3">
                                <Col className="text-center" sm={4}>
                                    <Label className="form-Label">Select Client</Label>
                                    <select
                                        className="form-select"
                                        onChange={(e) => {
                                            const currentClient = Number(e.target.value);
                                            setState({ ...state, currentClient });
                                        }}
                                    >
                                        <option value={0}> Select</option>
                                        {clients.sort((a: any, b: any) => a.id - b.id).map((item: any) => {
                                            return <option key={item.id} value={item.id}>{item.id + " - " + item.name.toUpperCase()}</option>;
                                        })}
                                    </select>
                                </Col>
                            </Row>
                            {state.currentClient ? <Row className="justify-content-center mb-3">
                                <Col className="text-center" sm={4}>
                                    <Label className="form-Label">Select Rol</Label>
                                    <select
                                        className="form-select"
                                        onChange={(e) => {
                                            const currentRol = Number(e.target.value);
                                            setState({
                                                ...state,
                                                currentRol,
                                                indexCurrentRol: roles.findIndex((item: any) => item.id === currentRol),
                                            });
                                        }}
                                    >
                                        <option value={0}> Select</option>
                                        {roles.map((item: any) => {
                                            return <option key={item.id} value={item.id}>{item.nombre.toUpperCase()}</option>;
                                        })}
                                    </select>
                                </Col>
                            </Row> : <></>}

                            {state.currentRol !== 0 ? <Row className="justify-content-center text-center mb-5">
                                <Col sm={4}>
                                    <div className="btn button w-50 fs-5" onClick={() => updateHandler()}>
                                        Save Rol
                                    </div>
                                </Col>
                            </Row> : null}

                            {state.currentRol !== 0 ? (
                                <Row className="justify-content-center">
                                    <Col sm={5}>
                                        <div className="text-center fs-4 pb-2">
                                            <Icon name="folder" className="icon-lg me-2 mb-1" />
                                            All Permissions
                                            <Input
                                                value={state.allPermissionQuery}
                                                onChange={(e) =>
                                                    setState({
                                                        ...state,
                                                        allPermissionQuery: e.target.value,
                                                    })
                                                }
                                                className="form-control text-center mt-3 mb-4"
                                                type="text"
                                                placeholder="Search Permissions"
                                                id="example-text-input"
                                            />
                                        </div>
                                        {state.currentRolNotPermissions.map((item: any, index: any) => {
                                            return (
                                                <div
                                                    key={index}
                                                    className="cardPermission">
                                                    <Row className="align-items-center">
                                                        <Col sm={9}>
                                                            <h4 className="fs-6 text-center">{item.nombre}</h4>
                                                        </Col>
                                                        <Col
                                                            sm={1}
                                                            className="btn button-icon iconPermission align-items-center justify-content-center d-flex"
                                                            onClick={() => changeHandler(item)}
                                                        >
                                                            <Icon name="chevron-right" className="icon-lg" />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            );
                                        })}
                                    </Col>
                                    <Col sm={5}>
                                        <div className="text-center fs-4 pb-2">
                                            <Icon name="folder-plus" className="icon-lg me-2 mb-1" />
                                            Current Permissions
                                            <Input
                                                value={state.currentPermissionQuery}
                                                onChange={(e) =>
                                                    setState({
                                                        ...state,
                                                        currentPermissionQuery: e.target.value,
                                                    })
                                                }
                                                className="form-control text-center mt-3 mb-4"
                                                type="text"
                                                placeholder="Search Permissions"
                                                id="example-text-input"
                                            />
                                        </div>
                                        {state.currentRolPermissions.map((item: any) => {
                                            return (
                                                <div
                                                    key={item.id}
                                                    className="cardPermission">
                                                    <Row className="align-items-center justify-content-end">
                                                        <Col
                                                            sm={1}
                                                            className="btn button-icon iconPermission align-items-center justify-content-center d-flex"
                                                            onClick={() => changeHandlerDelete(item.id)}
                                                        >
                                                            <Icon name="chevron-left" className="icon-lg" />
                                                        </Col>
                                                        <Col sm={9}>
                                                            <h4 className="fs-6 text-center">{item.nombre}</h4>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            );
                                        })}
                                    </Col>

                                </Row>
                            ) : (
                                <Row className="justify-content-center text-center mt-5">
                                    <Col sm={4}>
                                        <h5 className="mt-5 me-3">
                                            <Icon name="alert-triangle" className="icon-lg me-2 mb-1" /> {state.currentClient ? "Select a rol" : "Select a Client"}
                                        </h5>
                                    </Col>
                                </Row>
                            )}
                        </Container>
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );
}

export default RolMenu;
